module.exports = __webpack_public_path__ + "media/styles/images/svg/trash-red-910de687dd07c5e96e0411eb0ee529f1.svg";